import styled, { css } from 'styled-components';
import {
    GREY_500, GREEN_600, DIVIDER, WHITE,
} from '../../../constants';
import { COLLAPSED_COLUMN_WIDTH, COLUMN_WIDTH } from '../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    flex: 0 0 auto;
    border: 1px solid ${DIVIDER};

    > div:last-child {
        overflow: scroll;
        visibility: hidden;
        flex: none;
    }   
`;

export const Hours = styled.h4`
    flex: none;
    text-align: center;
    color: ${GREY_500};
    min-width: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.75rem;
`;

export const HeaderItems = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
    flex: 1 1 auto;
    overflow-y: hidden;
    overflow-x: hidden;

    > div:first-child {
        width: 5px;
        min-width: 5px;
        height: 100%;
        border-right: 1px solid ${DIVIDER};
    }
    > div:last-child {
        border-right: none;
    }
`;

export const HeaderItem = styled.div<{ $collapsed?: boolean }>`
    flex: 1 0 ${COLUMN_WIDTH};
    border-right: 1px solid ${DIVIDER};
    position: relative;
    min-width: ${COLUMN_WIDTH};
    white-space: nowrap;
    height: 100%;
    color: ${GREY_500};
    text-align: center;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;    
    padding: 0.1875rem 0.625rem;
    gap: 0.625rem;

    ${(props) => props.$collapsed && css`
        flex: 0 0 ${COLLAPSED_COLUMN_WIDTH};
        min-width: ${COLLAPSED_COLUMN_WIDTH};
        padding: 0.1875rem 0.25rem;
    `};
`;

export const Label = styled.span`
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.375rem;
`;

export const HeaderContent = styled.div`
    display: flex;
    width: 100%;
    min-width: 0;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
`;

export const AllDayItems = styled.div`
    display: flex;
    width: 100%;
    min-width: 0;
    flex-direction: column;
    gap: 0.125rem;
`;

export const HolidayChip = styled.div<{ $color: string }>`
    width: 100%;
    min-width: 0;
    padding: 0.125rem 0.375rem;
    border-radius: 0.25rem;
    background: ${GREEN_600};
    overflow: hidden;
    color: ${WHITE};
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1rem;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
